import { useState } from "react";
import { Check, ChevronsUpDown, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

export default function MoyenSelector({ moyensList = [], value, onSelect, onClear, testId }) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between font-normal"
          data-testid={testId}
        >
          <span className={cn("truncate", !value && "text-muted-foreground")}>
            {value || "Sélectionner un moyen..."}
          </span>
          <div className="flex items-center gap-1">
            {value && (
              <span
                role="button"
                tabIndex={-1}
                aria-label="Retirer ce moyen"
                onPointerDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onClear();
                }}
                className="rounded p-0.5 hover:bg-muted"
                data-testid={`${testId}-clear`}
              >
                <X className="h-4 w-4 opacity-60 hover:opacity-100" />
              </span>
            )}
            <ChevronsUpDown className="h-4 w-4 opacity-50" />
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[400px] p-0" align="start">
        <Command>
          <CommandInput placeholder="Rechercher un moyen..." />
          <CommandList>
            <CommandEmpty>Aucun moyen trouvé.</CommandEmpty>
            <CommandGroup>
              {moyensList.map((m) => (
                <CommandItem
                  key={m.moyen}
                  value={m.moyen}
                  onSelect={() => {
                    onSelect(m);
                    setOpen(false);
                  }}
                >
                  <Check className={cn("h-4 w-4", value === m.moyen ? "opacity-100" : "opacity-0")} />
                  <span className="text-sm">{m.moyen}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
